import { Locale } from 'chaika-enums';
export const medicalCase = {
    casesWorksAtVisit: {
        [Locale.Ru]: 'Эпизоды, с которыми работали на приеме',
        [Locale.Am]: 'Էպիզոդներ, որոնց հետ աշխատել են ընդունելության ժամանակ',
        [Locale.En]: 'Episodes worked with at the reception',
        [Locale.Pt]: 'Episódios trabalhados na recepção',
        [Locale.Ge]: 'ეპიზოდები, რომლებთანაც ვიმუშავეთ მიღებაზე',
    },
    chooseFromOpen: {
        [Locale.Ru]: 'или выберите из открытых',
        [Locale.Am]: 'կամ ընտրեք բացերից',
        [Locale.En]: 'or choose from open',
        [Locale.Pt]: 'ou escolha entre os abertos',
        [Locale.Ge]: 'ან აირჩიეთ ღია',
    },
    chooseCase: {
        [Locale.Ru]: 'Выберите эпизод',
        [Locale.Am]: 'Ընտրեք էպիզոդը',
        [Locale.En]: 'Choose an episode',
        [Locale.Pt]: 'Escolha um episódio',
        [Locale.Ge]: 'აირჩიე ეპიზოდი',
    },
    openCaseToSeeDescription: {
        [Locale.Ru]: 'Разверните эпизод, чтобы увидеть подробности',
        [Locale.Am]: 'Բացեք էպիզոդը՝ մանրամասները տեսնելու համար',
        [Locale.En]: 'Expand the episode to see the details',
        [Locale.Pt]: 'Expanda o episódio para ver os detalhes',
        [Locale.Ge]: 'გააფართოვე ეპიზოდი დეტალების სანახავად',
    },
    orAddNewEntry: {
        [Locale.Ru]: 'или добавить к нему текущую запись',
        [Locale.Am]: 'կամ ավելացնել դրան ընթացիկ գրառումը',
        [Locale.En]: 'or add the current record to it',
        [Locale.Pt]: 'ou adicione o registro atual a ele',
        [Locale.Ge]: 'ან დაამატეთ მას მიმდინარე ჩანაწერი',
    },
    yourEpisodes: {
        [Locale.Ru]: 'Ваши эпизоды',
        [Locale.Am]: 'Ձեր էպիզոդները',
        [Locale.En]: 'Your episodes',
        [Locale.Pt]: 'Seus episódios',
        [Locale.Ge]: 'თქვენი ეპიზოდები',
    },
    fromYourSpeciality: {
        [Locale.Ru]: 'По вашей специальности',
        [Locale.Am]: 'Ըստ ձեր մասնագիտության',
        [Locale.En]: 'According to your specialty',
        [Locale.Pt]: 'De acordo com sua especialidade',
        [Locale.Ge]: 'თქვენი სპეციალობის მიხედვით',
    },
    createNewCase: {
        [Locale.Ru]: 'Создать новый эпизод',
        [Locale.Am]: 'Ստեղծել նոր էպիզոդ',
        [Locale.En]: 'Create a new episode',
        [Locale.Pt]: 'Criar um novo episódio',
        [Locale.Ge]: 'ახალი ეპიზოდის შექმნა',
    },
    otherCases: {
        [Locale.Ru]: 'Другие эпизоды',
        [Locale.Am]: 'Այլ էպիզոդներ',
        [Locale.En]: 'Other episodes',
        [Locale.Pt]: 'Outros episódios',
        [Locale.Ge]: 'სხვა ეპიზოდები',
    },
    newCase: {
        [Locale.Ru]: 'Новый эпизод',
        [Locale.Am]: 'Նոր էպիզոդ',
        [Locale.En]: 'New Episode',
        [Locale.Pt]: 'Novo Episódio',
        [Locale.Ge]: 'ახალი ეპიზოდი',
    },
    newMedicalEpisode: {
        [Locale.Ru]: 'Новый эпизод медицинской помощи',
        [Locale.Am]: 'Բժշկական օգնության նոր էպիզոդ',
        [Locale.En]: 'New medical episode',
        [Locale.Pt]: 'Novo episódio médico',
        [Locale.Ge]: 'ახალი ეპიზოდი მედიცინირებული',
    },
    episodeAbout: {
        [Locale.Ru]: 'Эпизод по поводу',
        [Locale.Am]: 'Էպիզոդ՝ կապված',
        [Locale.En]: 'Episode about',
        [Locale.Ge]: 'Episode about',
        [Locale.Pt]: 'Episódio sobre',
    },
    frequentEpisodes: {
        [Locale.Ru]: 'Частые эпизоды',
        [Locale.Am]: 'Հաճախակի էպիզոդներ',
        [Locale.En]: 'Frequent episodes',
        [Locale.Ge]: 'Frequent episodes',
        [Locale.Pt]: 'Episódios frequentes',
    },
    medicalEpisode: {
        [Locale.Ru]: 'Эпизод медицинской помощи',
        [Locale.Am]: 'Բժշկական օգնության էպիզոդ',
        [Locale.En]: 'Medical episode',
        [Locale.Pt]: 'Episódio médico',
        [Locale.Ge]: 'ეპიზოდი მედიცინირებული',
    },
    editCase: {
        [Locale.Ru]: 'Редактирование эпизода',
        [Locale.Am]: 'Էպիզոդի խմբագրում',
        [Locale.En]: 'Episode Editing',
        [Locale.Pt]: 'Edição de Episódio',
        [Locale.Ge]: 'ეპიზოდის რედაქტირება',
    },
    editMedicalEpisode: {
        [Locale.Ru]: 'Редактирование эпизода медицинской помощи',
        [Locale.Am]: 'Բժշկական օգնության էպիզոդի խմբագրում',
        [Locale.En]: 'Editing a medical episode',
        [Locale.Pt]: 'Editando um episódio médico',
        [Locale.Ge]: 'ეპიზოდის მედიცინირებული რედაქტირება',
    },
    reasonOfVisit: {
        [Locale.Ru]: 'Описание / Причина обращения',
        [Locale.Am]: 'Նկարագրություն / Դիմելու պատճառ',
        [Locale.En]: 'Description / Reason for the request',
        [Locale.Pt]: 'Descrição / Motivo da solicitação',
        [Locale.Ge]: 'აღწერილობა / მოთხოვნის მიზეზი',
    },
    fullDescription: {
        [Locale.Ru]: 'Развернутое описание проблемы, с которой пришел пациент',
        [Locale.Am]: 'Պացիենտի բերած խնդրի մանրամասն նկարագրություն',
        [Locale.En]: 'A detailed description of the problem the patient came with',
        [Locale.Pt]: 'Uma descrição detalhada do problema que o paciente apresentou',
        [Locale.Ge]: 'პრობლემის დეტალური აღწერა, რომლითაც მოვიდა პაციენტი',
    },
    copyFromIllnessHistory: {
        [Locale.Ru]: 'Скопировать из истории болезни',
        [Locale.Am]: 'Պատճենել հիվանդության պատմությունից',
        [Locale.En]: 'Copy from illness history',
        [Locale.Pt]: 'Copiar do histórico de doenças',
        [Locale.Ge]: 'ისტორიების ისტორია',
    },
    deleteEpisode: {
        [Locale.Ru]: 'Удалить эпизод',
        [Locale.Am]: 'Ջնջել էպիզոդը',
        [Locale.En]: 'Delete episode',
        [Locale.Pt]: 'Excluir episódio',
        [Locale.Ge]: 'ეპიზოდის წაშლა',
    },
    formulateOnPatientLanguage: {
        [Locale.Ru]: 'Формулируйте на языке пациента',
        [Locale.Am]: 'Ձևակերպեք պացիենտի լեզվով',
        [Locale.En]: 'Formulate in the patients language',
        [Locale.Pt]: 'Formular na linguagem do paciente',
        [Locale.Ge]: 'ფორმულირება პაციენტის ენაზე',
    },
    understandableByThePatientIn: {
        [Locale.Ru]: 'Понятным пациенту языком:',
        [Locale.Am]: 'Պացիենտին հասկանալի լեզվով՝',
        [Locale.En]: 'Understandable by the patient in:',
        [Locale.Pt]: 'Compreensível pelo paciente em:',
        [Locale.Ge]: 'პაციენტის მიხედვით:',
    },
    caseManager: {
        [Locale.Ru]: 'Эпизод-менеджер',
        [Locale.Am]: 'Էպիզոդի մենեջեր',
        [Locale.En]: 'Episode Manager',
        [Locale.Pt]: 'Gerenciador de episódios',
        [Locale.Ge]: 'ეპიზოდის მენეჯერი',
    },
    diagnosisTreatmentPlanByVisit: {
        [Locale.Ru]: 'Диагноз и план лечения по поводу обращения:',
        [Locale.Am]: 'Ախտորոշում և բուժման պլան՝ ըստ դիմելու պատճառի՝',
        [Locale.En]: 'Diagnosis and treatment plan for treatment:',
        [Locale.Pt]: 'Diagnóstico e plano de tratamento para tratamento:',
        [Locale.Ge]: 'დიაგნოსტიკა და მკურნალობის გეგმა:',
    },
    caseDontHaveDiagnosis: {
        [Locale.Ru]: 'В этом эпизоде еще нет диагнозов',
        [Locale.Am]: 'Այս էպիզոդում դեռ ախտորոշումներ չկան',
        [Locale.En]: 'There are no diagnoses in this episode yet',
        [Locale.Pt]: 'Ainda não há diagnósticos neste episódio',
        [Locale.Ge]: 'ამ ეპიზოდში ჯერ არ არის დიაგნოზი',
    },
    diagnoses: {
        [Locale.Ru]: 'Диагнозы',
        [Locale.Am]: 'Ախտորոշումներ',
        [Locale.En]: 'Diagnoses',
        [Locale.Pt]: 'Diagnósticos',
        [Locale.Ge]: 'დიაგნოსტიკა',
    },
    addDiagnosis: {
        [Locale.Ru]: 'Добавить диагноз',
        [Locale.Am]: 'Ավելացնել ախտորոշում',
        [Locale.En]: 'Add a diagnosis',
        [Locale.Pt]: 'Adicionar um diagnóstico',
        [Locale.Ge]: 'დაამატე დიაგნოზი',
    },
    openFavourite: {
        [Locale.Ru]: 'Открыть избранное',
        [Locale.Am]: 'Բացել ընտրյալները',
        [Locale.En]: 'Open favourite',
        [Locale.Pt]: 'Abrir favorito',
        [Locale.Ge]: 'გადმოწერი',
    },
    addDiagnosisYou: {
        [Locale.Ru]: 'Добавьте диагноз',
        [Locale.Am]: 'Ավելացրեք ախտորոշում',
        [Locale.En]: 'Add a diagnosis',
        [Locale.Pt]: 'Adicionar um diagnóstico',
        [Locale.Ge]: 'დაამატე დიაგნოზი',
    },
    addMoreDiagnosis: {
        [Locale.Ru]: 'Добавить диагноз',
        [Locale.Am]: 'Ավելացնել ախտորոշում',
        [Locale.En]: 'Add a diagnosis',
        [Locale.Pt]: 'Adicionar um diagnóstico',
        [Locale.Ge]: 'დაამატე დიაგნოზი',
    },
    casePaused: {
        [Locale.Ru]: 'Эпизод приостановлен',
        [Locale.Am]: 'Էպիզոդը կասեցված է',
        [Locale.En]: 'Episode paused',
        [Locale.Pt]: 'Episódio pausado',
        [Locale.Ge]: 'ეპიზოდი შეჩერებულია',
    },
    caseClosed: {
        [Locale.Ru]: 'Эпизод закрыт',
        [Locale.Am]: 'Էպիզոդը փակված է',
        [Locale.En]: 'Episode closed',
        [Locale.Pt]: 'Episódio encerrado',
        [Locale.Ge]: 'ეპიზოდი დახურულია',
    },
    reasonOfAppeal: {
        [Locale.Ru]: 'Повод обращения (эпизод)',
        [Locale.Am]: 'Դիմելու պատճառ (էպիզոդ)',
        [Locale.En]: 'The reason for the appeal (episode)',
        [Locale.Pt]: 'O motivo do recurso (episódio)',
        [Locale.Ge]: 'აპელაციის მიზეზი (ეპიზოდი)',
    },
    attachToThisEntry: {
        [Locale.Ru]: 'Прикрепить к этой записи',
        [Locale.Am]: 'Կցել այս գրառմանը',
        [Locale.En]: 'Attach to this entry',
        [Locale.Pt]: 'Anexar a esta entrada',
        [Locale.Ge]: 'მიურთეთ ამ პოსტს',
    },
    deleteCase: {
        [Locale.Ru]: 'Удалить эпизод',
        [Locale.Am]: 'Ջնջել էպիզոդը',
        [Locale.En]: 'Delete the episode',
        [Locale.Pt]: 'Exclua o episódio',
        [Locale.Ge]: 'წაშალე ეპიზოდი',
    },
    deleteFromEntry: {
        [Locale.Ru]: 'Убрать из записи',
        [Locale.Am]: 'Հեռացնել գրառումից',
        [Locale.En]: 'Remove from entry',
        [Locale.Pt]: 'Remover da entrada',
        [Locale.Ge]: 'ამოღება შესვლიდან',
    },
    errorWhenUnpinningCase: {
        [Locale.Ru]: 'Ошибка при откреплении эпизода',
        [Locale.Am]: 'Էպիզոդի անջատման սխալ',
        [Locale.En]: 'Error when unpinning the episode',
        [Locale.Pt]: 'Erro ao liberar o episódio',
        [Locale.Ge]: 'შეცდომა ეპიზოდის მოხსნისას',
    },
    youWantToAddCompletedEpisode: {
        [Locale.Ru]: 'Вы хотите добавить завершенный эпизод',
        [Locale.Am]: 'Դուք ցանկանում եք ավելացնել ավարտված էպիզոդ',
        [Locale.En]: 'You want to add a completed episode',
        [Locale.Pt]: 'Você deseja adicionar um episódio completo',
        [Locale.Ge]: 'დაამატეთ დახურული ეპიზოდი',
    },
    whenAddingCompletedEpisode: {
        [Locale.Ru]: 'При добавлении завершенного эпизода в текущую запись он будет открыт заново, а вы будете менеджером эпизода',
        [Locale.Am]: 'Ավարտված էպիզոդը ընթացիկ գրառմանն ավելացնելիս այն կրկին կբացվի, իսկ դուք կլինեք էպիզոդի մենեջերը',
        [Locale.En]: 'When adding a completed episode to the current entry, it will be opened again, and you will be the manager of the episode',
        [Locale.Pt]: 'Ao adicionar um episódio concluído à entrada atual, ele será aberto novamente e você será o gerente do episódio',
        [Locale.Ge]: 'დაამატეთ დახურული ეპიზოდი შენ მშობლის ეპიზოდისთვის',
    },
    caseCannotBeRemovedFromParentEntry: {
        [Locale.Ru]: 'Эпизод нельзя удалить из родительской записи',
        [Locale.Am]: 'Էպիզոդը հնարավոր չէ ջնջել ծնող գրառումից',
        [Locale.En]: 'The episode cannot be removed from the parent entry',
        [Locale.Pt]: 'O episódio não pode ser removido do registro pai',
        [Locale.Ge]: 'ეპიზოდის წაშლა მშობლის ჩანაწერიდან შეუძლებელია',
    },
    caseCannotBeRemovedFromEntry: {
        [Locale.Ru]: 'Эпизод нельзя удалить из записи при наличии ответа на направления и новых событий в плане лечения по эпизоду',
        [Locale.Am]: 'Էպիզոդը հնարավոր չէ ջնջել գրառումից, եթե կան ուղեգրերի պատասխան և նոր իրադարձություններ էպիզոդի բուժման պլանում',
        [Locale.En]: 'The episode cannot be removed from the entry if there is a response to referrals and new events in the episode treatment plan',
        [Locale.Pt]: 'O episódio não pode ser removido do registro caso haja resposta a encaminhamentos e novos eventos no plano de tratamento do episódio',
        [Locale.Ge]: 'ეპიზოდის წაშლა ჩანაწერიდან შეუძლებელია, როდესაც არის რეაგირება რეფერალებზე და ახალი მოვლენები მკურნალობის გეგმაში ეპიზოდის მიხედვით',
    },
    caseCannotBeRemovedFromEntryHasRelatedItems: {
        [Locale.Ru]: 'Эпизод нельзя удалить из записи. По этому эпизоду есть:',
        [Locale.Am]: 'Էպիզոդը հնարավոր չէ ջնջել գրառումից։ Այս էպիզոդով կան՝',
        [Locale.En]: 'The episode cannot be removed from the entry. This episode has:',
        [Locale.Pt]: 'O episódio não pode ser removido do registro. Este episódio possui:',
        [Locale.Ge]: 'ეპიზოდის წაშლა ჩანაწერიდან შეუძლებელია. ამ ეპიზოდს აქვს:',
    },
    confirmRemoveMedicalCaseWithRelatedTitle: {
        [Locale.Ru]: 'Удалить эпизод?',
        [Locale.Am]: 'Ջնջե՞լ դրվագը։',
        [Locale.En]: 'Delete the episode?',
        [Locale.Pt]: 'Excluir o episódio?',
        [Locale.Ge]: 'წავშალოთ ეპიზოდი?',
    },
    confirmRemoveMedicalCaseWithRelatedDescription: {
        [Locale.Ru]: 'Вместе с эпизодом будут удалены связанные задачи, рекомендации, направления вне записи и лекарства, а активные направления будут отменены.',
        [Locale.Am]: 'Դրվագի հետ միասին կջնջվեն կապակցված առաջադրանքները, առաջարկները, գրառումից դուրս ուղեգրերը և դեղամիջոցները, իսկ ակտիվ ուղեգրերը կչեղարկվեն։',
        [Locale.En]: 'Deleting the episode will also remove related tasks, recommendations, outward referrals and drugs, and cancel active referrals.',
        [Locale.Pt]: 'Excluir o episódio também removerá tarefas, recomendações, encaminhamentos externos e medicamentos relacionados, e cancelará encaminhamentos ativos.',
        [Locale.Ge]: 'ეპიზოდთან ერთად წაიშლება დაკავშირებული ამოცანები, რეკომენდაციები, გარე რეფერალები და მედიკამენტები, ხოლო აქტიური რეფერალები გაუქმდება.',
    },
    noCasesAdded: {
        [Locale.Ru]: 'Нет добавленных эпизодов',
        [Locale.Am]: 'Ավելացված էպիզոդներ չկան',
        [Locale.En]: 'No episodes added',
        [Locale.Pt]: 'Nenhum episódio adicionado',
        [Locale.Ge]: 'არ არის დამატებული ეპიზოდები',
    },
    treatmentPlan: {
        [Locale.Ru]: 'План лечения',
        [Locale.Am]: 'Բուժման պլան',
        [Locale.En]: 'Treatment plan',
        [Locale.Pt]: 'Plano de tratamento',
        [Locale.Ge]: 'მკურნალობის გეგმა',
    },
    accordingToICD: {
        [Locale.Ru]: 'По МКБ',
        [Locale.Am]: 'Ըստ ՀՄԴ',
        [Locale.En]: 'By ICD',
        [Locale.Pt]: 'Por CDI',
        [Locale.Ge]: 'ICD-ის მიხედვით',
    },
    ICD: {
        [Locale.Ru]: 'Код МКБ-10',
        [Locale.Am]: 'ՀՄԴ-10 կոդ',
        [Locale.En]: 'By ICD-10',
        [Locale.Pt]: 'Pela CID-10',
        [Locale.Ge]: 'ICD-ის მიხედვით',
    },
    descriptionOfDiagnosis: {
        [Locale.Ru]: 'Описание диагноза',
        [Locale.Am]: 'Ախտորոշման նկարագրություն',
        [Locale.En]: 'Description of diagnosis',
        [Locale.Pt]: 'Descrição do diagnóstico',
        [Locale.Ge]: 'Description of diagnosis',
    },
    selectICDStatusCode: {
        [Locale.Ru]: 'Выберите код состояния по МКБ',
        [Locale.Am]: 'Ընտրեք վիճակի կոդն ըստ ՀՄԴ',
        [Locale.En]: 'Select the ICD status code',
        [Locale.Pt]: 'Selecione o código de status do ICD',
        [Locale.Ge]: 'აირჩიეთ ICD სტატუსის კოდი',
    },
    specifyICDStatusCode: {
        [Locale.Ru]: 'Пожалуйста, укажите код состояния по МКБ',
        [Locale.Am]: 'Խնդրում ենք նշել վիճակի կոդն ըստ ՀՄԴ',
        [Locale.En]: 'Please specify the ICD status code',
        [Locale.Pt]: 'Especifique o código de status do ICD',
        [Locale.Ge]: 'გთხოვთ, შეიყვანოთ ICD სტატუსის კოდი',
    },
    diagnosis: {
        [Locale.Ru]: 'Диагноз',
        [Locale.Am]: 'Ախտորոշում',
        [Locale.En]: 'Diagnosis',
        [Locale.Pt]: 'Diagnóstico',
        [Locale.Ge]: 'დიაგნოსტიკა',
    },
    diagnosisDescription: {
        [Locale.Ru]: 'Описание диагноза',
        [Locale.Am]: 'Ախտորոշման նկարագրություն',
        [Locale.En]: 'Diagnosis description',
        [Locale.Pt]: 'Descrição do diagnóstico',
        [Locale.Ge]: 'დიაგნოზის აღწერა',
    },
    clarificationOfDiagnosis: {
        [Locale.Ru]: 'Уточнение диагноза по МКБ. Короткое заключение о сути заболевания. Перечень состояний для дифференциальной диагностики',
        [Locale.Am]: 'Ախտորոշման ճշտում ըստ ՀՄԴ։ Կարճ եզրակացություն հիվանդության էության մասին։ Դիֆերենցիալ ախտորոշման համար վիճակների ցանկ',
        [Locale.En]: 'Clarification of the diagnosis by ICD. A short conclusion about the essence of the disease. List of conditions for differential diagnosis',
        [Locale.Pt]: 'Esclarecimento do diagnóstico pelo CDI. Uma breve conclusão sobre a essência da doença. Lista de condições para diagnóstico diferencial',
        [Locale.Ge]: 'დიაგნოზის დაზუსტება ICD-ის მიხედვით. მოკლე დასკვნა დაავადების არსის შესახებ. დიფერენციალური დიაგნოზის პირობების ჩამონათვალი',
    },
    formulateDiagnosis: {
        [Locale.Ru]: 'Пожалуйста, сформулируйте диагноз',
        [Locale.Am]: 'Խնդրում ենք ձևակերպել ախտորոշումը',
        [Locale.En]: 'Please formulate a diagnosis',
        [Locale.Pt]: 'Por favor, formule um diagnóstico',
        [Locale.Ge]: 'გთხოვთ ჩამოაყალიბოთ დიაგნოზი',
    },
    addToCase: {
        [Locale.Ru]: 'Добавить к эпизоду',
        [Locale.Am]: 'Ավելացնել էպիզոդին',
        [Locale.En]: 'Add to episode',
        [Locale.Pt]: 'Adicionar ao episódio',
        [Locale.Ge]: 'ეპიზოდში დამატება',
    },
    deleteDiagnosis: {
        [Locale.Ru]: 'Удалить диагноз',
        [Locale.Am]: 'Ջնջել ախտորոշումը',
        [Locale.En]: 'Delete diagnosis',
        [Locale.Pt]: 'Excluir diagnóstico',
        [Locale.Ge]: 'დიაგნოზის წაშლა',
    },
    newDiagnosis: {
        [Locale.Ru]: 'Новый диагноз',
        [Locale.Am]: 'Նոր ախտորոշում',
        [Locale.En]: 'New diagnosis',
        [Locale.Pt]: 'Novo diagnóstico',
        [Locale.Ge]: 'ახალი დიაგნოზი',
    },
    changeDiagnosis: {
        [Locale.Ru]: 'Изменение диагноза',
        [Locale.Am]: 'Ախտորոշման փոփոխում',
        [Locale.En]: 'Change diagnosis',
        [Locale.Pt]: 'Diagnóstico de alterações',
        [Locale.Ge]: 'დიაგნოზის შეცვლა',
    },
    haventAddedDiagnosis: {
        [Locale.Ru]: 'Вы ещё не добавили диагнозов в избранное',
        [Locale.Am]: 'Դուք դեռ ախտորոշումներ չեք ավելացրել ընտրյալներում',
        [Locale.En]: `You haven't added diagnoses to favorites yet`,
        [Locale.Pt]: `Você ainda não adicionou diagnósticos aos favoritos`,
        [Locale.Ge]: 'თქვენ ჯერ არ დაუმატებიათ დიაგნოზები რჩეულებში',
    },
    addedToCase: {
        [Locale.Ru]: 'Добавлено в эпизод',
        [Locale.Am]: 'Ավելացվել է էպիզոդում',
        [Locale.En]: 'Added to the episode',
        [Locale.Pt]: 'Adicionado ao episódio',
        [Locale.Ge]: 'დამატებულია ეპიზოდში',
    },
    delivered: {
        [Locale.Ru]: 'Поставлен',
        [Locale.Am]: 'Դրված է',
        [Locale.En]: 'Delivered',
        [Locale.Pt]: 'Entregue',
        [Locale.Ge]: 'განლაგებულია',
    },
    byAssistant: {
        [Locale.Ru]: 'Ассистентом',
        [Locale.Am]: 'Օգնականի կողմից',
        [Locale.En]: 'Assistant',
        [Locale.Pt]: 'Assistente',
        [Locale.Ge]: 'ასისტენტი',
    },
    byDoctor: {
        [Locale.Ru]: 'Доктором',
        [Locale.Am]: 'Բժշկի կողմից',
        [Locale.En]: 'Doctor',
        [Locale.Pt]: 'Médico',
        [Locale.Ge]: 'ექიმი',
    },
    openedCase: {
        [Locale.Ru]: 'Эпизод открыт',
        [Locale.Am]: 'Էպիզոդը բացված է',
        [Locale.En]: 'Episode has been opened',
        [Locale.Pt]: 'O episódio foi aberto',
        [Locale.Ge]: 'ეპიზოდი გახსნილია',
    },
    endEpisode: {
        [Locale.Ru]: 'Завершить эпизод',
        [Locale.Am]: 'Ավարտել էպիզոդը',
        [Locale.En]: 'End the episode',
        [Locale.Pt]: 'Terminar o episódio',
        [Locale.Ge]: 'ეპიზოდის დასრულება',
    },
    takeIt: {
        [Locale.Ru]: 'Взять себе',
        [Locale.Am]: 'Վերցնել ինձ',
        [Locale.En]: 'Take it for yourself',
        [Locale.Pt]: 'Leve para você',
        [Locale.Ge]: 'ეპიზოდის დასრულება',
    },
    episodeTakenBy: {
        [Locale.Ru]: 'Эпизод забрал себе $author',
        [Locale.Am]: 'Էպիզոդը վերցրել է $author',
        [Locale.En]: 'Episode taken by $author',
        [Locale.Pt]: 'Episódio assumido por $author',
        [Locale.Ge]: 'ეპიზოდი აიღო $author',
    },
    episodeClosedBy: {
        [Locale.Ru]: 'Эпизод закрыт $date. $author',
        [Locale.Am]: 'Էպիզոդը փակվել է $date։ $author',
        [Locale.En]: 'Episode closed on $date. $author',
        [Locale.Pt]: 'Episódio encerrado em $date. $author',
        [Locale.Ge]: 'ეპიზოდი დაიხურა $date. $author',
    },
    unansweredReferrals: {
        [Locale.Ru]: 'неотвеченные направления',
        [Locale.Am]: 'չպատասխանված ուղեգրեր',
        [Locale.En]: 'unanswered referrals',
        [Locale.Pt]: 'referências não respondidas',
        [Locale.Ge]: 'უპასუხო რეფერალები',
    },
    unfinishedEvents: {
        [Locale.Ru]: 'незавершенные события',
        [Locale.Am]: 'չավարտված իրադարձություններ',
        [Locale.En]: 'unfinished events',
        [Locale.Pt]: 'eventos inacabados',
        [Locale.Ge]: 'დაუმთავრებელი მოვლენები',
    },
    prescribedMedications: {
        [Locale.Ru]: 'назначенные медикаменты',
        [Locale.Am]: 'նշանակված դեղամիջոցներ',
        [Locale.En]: 'prescribed medications',
        [Locale.Pt]: 'medicamentos prescritos',
        [Locale.Ge]: 'დადგენილი მედიკამენტები',
    },
    episodeLeft: {
        [Locale.Ru]: 'В эпизоде остались',
        [Locale.Am]: 'Էպիզոդում մնացել են',
        [Locale.En]: 'The episode left',
        [Locale.Pt]: 'O episódio saiu',
        [Locale.Ge]: 'ეპიზოდი დარჩა',
    },
    endOfEpisodeCanceled: {
        [Locale.Ru]: 'При завершении эпизода они будут отменены',
        [Locale.Am]: 'Էպիզոդն ավարտելիս դրանք կչեղարկվեն',
        [Locale.En]: 'At the end of the episode, they will be canceled',
        [Locale.Pt]: 'No final do episódio, eles serão cancelados',
        [Locale.Ge]: 'ეპიზოდის ბოლოს ისინი გაუქმდება',
    },
    endingEpisode: {
        [Locale.Ru]: 'Завершение эпизода',
        [Locale.Am]: 'Էպիզոդի ավարտում',
        [Locale.En]: 'Ending the episode',
        [Locale.Pt]: 'Terminando o episódio',
        [Locale.Ge]: 'ეპიზოდის დასრულება',
    },
    backToEpisode: {
        [Locale.Ru]: 'Вернуться к эпизоду',
        [Locale.Am]: 'Վերադառնալ էպիզոդին',
        [Locale.En]: 'Go back to the episode',
        [Locale.Pt]: 'Volte para o episódio',
        [Locale.Ge]: 'დავუბრუნდეთ ეპიზოდს',
    },
    setByDoctor: {
        [Locale.Ru]: 'Поставлен доктором',
        [Locale.Am]: 'Դրվել է բժշկի կողմից',
        [Locale.En]: 'Placed by doctor',
        [Locale.Pt]: 'Colocado pelo médico',
        [Locale.Ge]: 'Placed by doctor',
    },
    chronic: {
        [Locale.Ru]: 'Хронический',
        [Locale.Am]: 'Քրոնիկ',
        [Locale.En]: 'Chronic',
        [Locale.Pt]: 'Crônico',
        [Locale.Ge]: 'Chronic',
    },
    acute: {
        [Locale.Ru]: 'Острый',
        [Locale.Am]: 'Սուր',
        [Locale.En]: 'Acute',
        [Locale.Pt]: 'Afiado',
        [Locale.Ge]: 'Acute',
    },
    preventative: {
        [Locale.Ru]: 'Профилактический',
        [Locale.Am]: 'Կանխարգելիչ',
        [Locale.En]: 'Preventative',
        [Locale.Pt]: 'Preventivo',
        [Locale.Ge]: 'Preventative',
    },
    chooseForCurrentEntry: {
        [Locale.Ru]: 'Выбрать для текущей записи',
        [Locale.Am]: 'Ընտրել ընթացիկ գրառման համար',
        [Locale.En]: 'Choose for current entry',
        [Locale.Pt]: 'Escolha a entrada atual',
        [Locale.Ge]: 'Choose for current entry',
    },
    removeFromCurrentEntry: {
        [Locale.Ru]: 'Убрать из текущей записи',
        [Locale.Am]: 'Հեռացնել ընթացիկ գրառումից',
        [Locale.En]: 'Remove from current entry',
        [Locale.Pt]: 'Remover da entrada atual',
        [Locale.Ge]: 'Remove from current entry',
    },
    moreAboutTheEpisode: {
        [Locale.Ru]: 'Подробнее об эпизоде',
        [Locale.Am]: 'Ավելին էպիզոդի մասին',
        [Locale.En]: 'More about the episode',
        [Locale.Pt]: 'Mais sobre o episódio',
        [Locale.Ge]: 'More about the episode',
    },
    closeComment: {
        [Locale.Ru]: 'Комментарий при закрытии',
        [Locale.Am]: 'Մեկնաբանություն փակելիս',
        [Locale.En]: 'Episode close comment',
        [Locale.Pt]: 'Comentário de encerramento do episódio',
        [Locale.Ge]: 'Episode close comment',
    },
};
